import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

import { useUser } from '@/modules/auth/hooks/useUser.ts'

export const PostHogAnalytics = () => {
  const { user } = useUser()
  const posthog = usePostHog()

  useEffect(() => {
    if (user && posthog) {
      posthog.identify(user.rowId, {
        email: user.emailAddress,
        name: user.name,
      })
    }
  }, [user, posthog])
  return null
}
